import React from 'react';
import { Section } from './Section';
import { Building2, ShoppingBag, HeartPulse, Users } from 'lucide-react';
import { motion } from 'framer-motion';
const industries = [{
  icon: Building2,
  title: 'Banks & Financial',
  desc: 'High-value environments with constant public exposure.'
}, {
  icon: ShoppingBag,
  title: 'Retail Chains',
  desc: 'Distributed locations that need centralized monitoring without complexity.'
}, {
  icon: HeartPulse,
  title: 'Hospitals & Clinics',
  desc: 'Sensitive environments where distress detection can save lives.'
}, {
  icon: Users,
  title: 'Public-Facing Business',
  desc: 'Offices, government buildings, transit hubs, leisure venues.'
}];
export function Industries() {
  return <Section id="industries" className="bg-white" data-id="element-104">
      <div className="text-center mb-12" data-id="element-105">
        <span className="text-peoplecall tracking-wider text-sm font-semibold mb-4 block" data-id="element-106">
          Designed for
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-zinc-900" data-id="element-107">
          Where people gather, risk gathers too.
        </h2>
        <p className="text-xl text-zinc-600 max-w-2xl mx-auto" data-id="element-108">
          If your doors are open to the public, Peoplecall Pod belongs inside
          them.
        </p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="relative mb-12 rounded-2xl overflow-hidden border border-zinc-200 shadow-sm" data-id="element-109">
        <img src="https://cdn.magicpatterns.com/uploads/oB3us5i6DFYzLCByXdqarV/mic-under-table.png" alt="Peoplecall Pod microphone discreetly installed in a bank reception area" className="w-full h-[320px] md:h-[480px] object-cover object-bottom" data-id="element-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-900/80 via-zinc-900/20 to-transparent" data-id="element-111" />
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10" data-id="element-112">
          <p className="text-white text-lg md:text-xl font-medium max-w-xl drop-shadow" data-id="element-113">
            Discreetly installed. Always vigilant. Protecting real environments
            where it matters most.
          </p>
        </div>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-114">
        {industries.map((ind, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white border border-zinc-200 p-8 rounded-2xl flex flex-col items-center text-center hover:border-peoplecall/40 hover:shadow-lg transition-all duration-300 hover:-translate-y-1" data-id="element-115">
            <div className="w-16 h-16 rounded-full bg-zinc-50 flex items-center justify-center mb-6 border border-zinc-200" data-id="element-116">
              <ind.icon className="w-8 h-8 text-zinc-900" data-id="element-117" />
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-3" data-id="element-118">
              {ind.title}
            </h3>
            <p className="text-zinc-600 text-sm" data-id="element-119">{ind.desc}</p>
          </motion.div>)}
      </div>
    </Section>;
}